/*
SPDX-FileCopyrightText: 2023 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { format } from 'date-fns';
export function convertToPath(name) {
    var path = name.toLowerCase();
    return "/" + path.replace(/\s+/g, '-');
}
export function formatDate(text) {
    try {
        var date = new Date(text);
        return format(date, 'dd/MM/yyyy HH:mm');
    }
    catch (_a) {
        return text;
    }
}
export function stopPropagation(e) {
    e.stopPropagation();
}
export function isPropDefined(prop) {
    return prop !== undefined;
}
export function falseIfUndefined(prop) {
    if (prop) {
        return true;
    }
    return false;
}
export function isEmptyObject(x) {
    return Object.keys(x).length === 0;
}
export function normaliseCaps(name, endpoint) {
    if (!name)
        return "";
    // make object ids clear (for auto load)
    if (endpoint !== undefined) {
        if (name === "id" || name === "uid") {
            return normaliseCaps(endpoint) + " ID";
        }
    }
    // replace relationship '.' with underscore ready to split
    name = name.replace('.', '_');
    var words = name.split('_');
    for (var count = 0; count < words.length; count++) {
        words[count] = normaliseWords(words[count]);
    }
    return words.join(' ');
}
function normaliseWords(word) {
    switch (word) {
        case "uid":
        case "id":
            return "ID";
        case "sts":
            return "STS";
        case "tolqc":
            return "ToLQC";
        case "tolid":
            return "ToLID";
        case "tol":
            return "ToL";
        case "eln":
            return "ELN";
        case "dna":
            return "DNA";
        case "rna":
            return "RNA";
        case "mlwh":
            return "MLWH";
        case "api":
            return "API";
        case "gal":
            return "GAL";
        case "qc":
            return "QC";
        case "bnt":
            return "BnT";
        case "tubeid":
            return "Tube ID";
        default:
            return word[0].toUpperCase() + word.substring(1);
    }
}
export function getCssVarValue(variable) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
}
export function timeout(delay) {
    return new Promise(function (res) { return setTimeout(res, delay); });
}
export function matomoAnalytics(siteId) {
    if (siteId) {
        var _paq_1 = window["_paq"] = window["_paq"] || [];
        // tracker methods like "setCustomDimension" should be called before "trackPageView"
        _paq_1.push(['trackPageView']);
        _paq_1.push(['enableLinkTracking']);
        (function () {
            var u = "https://matomo.sanger.ac.uk/";
            _paq_1.push(['setTrackerUrl', u + 'matomo.php']);
            _paq_1.push(['setSiteId', siteId]);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        })();
    }
}
export function numberWithSpaces(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}
export function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}
export function isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
}
export function deepCopy(o) {
    if (o === undefined)
        return {};
    return JSON.parse(JSON.stringify(o));
}
export function capitaliseFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
